export default "__VITE_ASSET__19741957__"